exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page-about .mdl-card_title i.adv-info{margin:0 -15px 10px 5px;vertical-align:middle}#page-about .mdl-card_title{font-size:larger}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b54e4602!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionContact.vue
// module id = 235
// module chunks = 0